import { HttpError, activateRefusalDetailsSchema, type LaunchReadiness } from '@vagusx/clients';

/**
 * Why the server would not publish or start a campaign, in the form the Launch
 * screen shows (ADR-318, G): the launch checks a refused activate (or publish
 * over a running campaign) carries in `details.launchReadiness`, and the field
 * errors publish raises for what cannot run (`sequence.<i>.workflow`, …).
 */
export interface Refusal {
  readiness: LaunchReadiness | null;
  fieldErrors: Array<{ field: string; message: string }>;
}

/** Null for an error that is neither, which stays with the global error toast. */
export function refusalFrom(err: unknown): Refusal | null {
  if (!(err instanceof HttpError)) return null;
  const parsed = activateRefusalDetailsSchema.safeParse(err.details);
  const readiness = parsed.success ? parsed.data.launchReadiness : null;
  const fieldErrors = err.fieldErrors
    .filter((e) => e.field !== '_form')
    .map((e) => ({ field: e.field, message: e.message }));
  return readiness || fieldErrors.length ? { readiness, fieldErrors } : null;
}

/** `sequence.2.workflow` → index 2, for naming the step a field error is about. */
export function stepIndexOf(field: string): number | null {
  const match = /^sequence\.(\d+)\./.exec(field);
  return match ? Number(match[1]) : null;
}
